<!--

	A loader that can be used to show a loading indicator while the VueList is loading.

	We use v-show instead of v-else, because v-else would remove the element from the DOM,
	and the VueList needs to be rendered on mount in order to start fetching data.

-->

<template>
	<div v-if="loading">
		<slot name="loading">
			<div class="mia-VueListLoader-spinner">
				<v-progress-circular indeterminate />
			</div>
		</slot>
	</div>
	<div v-show="!loading" class="mia-VueListLoader-content">
		<slot />
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { VProgressCircular } from "vuetify/components";

export default defineComponent({
	name: "VueListLoader",
	components: {
		VProgressCircular,
	},
	props: {
		loading: {
			type: Boolean,
			default: false,
		},
	},
});
</script>

<style lang="scss">
.mia-VueListLoader-content {
	display: contents;
}

.mia-VueListLoader-spinner {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	margin: theme.$mia-margin-size-large;
}
</style>
